var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Box, Heading, Image, Text, Input, SimpleGrid } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import Typewriter from 'typewriter-effect';
import { Select } from 'chakra-react-select';
import './Experimental.css';
import planet from './Planet-4.png';
var Experimental = function (props) {
    var _a = useState(null), selectedPlanet = _a[0], setSelectedPlanet = _a[1];
    var _b = useState(''), normalWeight = _b[0], setNormalWeight = _b[1];
    var _c = useState(''), weight = _c[0], setWeight = _c[1];
    var inputRef = React.useRef(null);
    var planetOptions = [
        { value: 'venus', label: 'Venus' },
        { value: 'mercury', label: 'Mercury' },
        { value: 'mars', label: 'Mars' },
        { value: 'saturn', label: 'Saturn' },
        { value: 'jupiter', label: 'Jupiter' },
        { value: 'uranus', label: 'Uranus' },
        { value: 'neptune', label: 'Neptune' },
    ];
    function getWeight(normal, planet) {
        switch (planet) {
            case 'venus':
                return normal * 0.91;
            case 'mercury':
                return normal * 0.38;
            case 'mars':
                return normal * 0.38;
            case 'jupiter':
                return normal * 2.34;
            case 'saturn':
                return normal * 0.93;
            case 'uranus':
                return normal * 0.92;
            case 'neptune':
                return normal * 0.92;
            default:
                return normal;
        }
    }
    useEffect(function () {
        console.log(selectedPlanet);
    }, [setSelectedPlanet]);
    return (_jsxs(Box, __assign({ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: 'column', h: "75vh" }, { children: [_jsx(Box, __assign({ display: "flex", justifyContent: "center", alignItems: "center", mt: '8rem' }, { children: _jsxs(Heading, __assign({ className: "title", textTransform: 'uppercase', fontSize: "4rem" }, { children: ["Your Weight on", ' ', _jsx(Typewriter, { options: {
                                strings: ['Mars', 'Venus', 'Mercury', 'Jupiter', 'Saturn', 'Uranus', 'Neptune', 'Pluto'],
                                autoStart: true,
                                loop: true,
                            } })] })) })), _jsx(Image, { src: planet, zIndex: "-99", width: "480px", opacity: '.5', position: 'absolute', top: "50px", left: "60px" }), _jsxs(SimpleGrid, __assign({ columns: 2, w: "75%", my: 10, display: "flex", justifyContent: "center", alignItems: "center" }, { children: [_jsx(Box, __assign({ w: "md", overflow: 'hidden' }, { children: _jsx(Text, __assign({ className: "title", fontSize: '1.8rem', margin: "0 auto", textTransform: 'uppercase', wordBreak: "break-word" }, { children: selectedPlanet ? (_jsxs(Box, { children: [_jsxs(Text, __assign({ my: 2, noOfLines: 2, textOverflow: "ellipsis" }, { children: ["Your weight on Earth: ", normalWeight, "kg"] })), _jsxs(Text, __assign({ noOfLines: 2 }, { children: ["Your weight on ", selectedPlanet.label, ": ", getWeight(parseInt(normalWeight), selectedPlanet.value), "kg"] }))] })) : ('No Data Entered') })) })), _jsxs(Box, __assign({ backgroundColor: '#19113C', w: "md", className: "form", borderRadius: '20px', padding: "20px", float: 'right' }, { children: [' ', _jsxs(Box, __assign({ mb: 2 }, { children: [_jsx(Text, __assign({ mb: 1 }, { children: " Weight(kg): " })), _jsx(Input, { placeholder: "Weight(kg*)", "aria-label": "weight in kg", onChange: function (e) { return setNormalWeight(e.target.value); }, type: "number" })] })), _jsx(Select, { name: "colors", className: "chakra-react-select", classNamePrefix: "chakra-react-select", options: planetOptions, placeholder: "Select a planet", selectedOptionStyle: "check", onChange: setSelectedPlanet, chakraStyles: {
                                    dropdownIndicator: function (provided) { return (__assign(__assign({}, provided), { bg: 'transparent', px: 2, cursor: 'inherit' })); },
                                    indicatorSeparator: function (provided) { return (__assign(__assign({}, provided), { display: 'none' })); },
                                } })] }))] }))] })));
};
export default Experimental;
